// extracted by mini-css-extract-plugin
module.exports = {"container":"LabStart_container__3SQ1e","btnDefault":"LabStart_btnDefault__2PSnq"};